import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { isActionFactory } from '../isActionFactory';
import { NewWorkbookForEditDatasource } from '../AppActionTypes';


export interface EditDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function editDatasource(contentInfo: IContentInfo): EditDatasourceAction {
  return {
    type: NewWorkbookForEditDatasource,
    contentInfo
  };
}

export const isEditDatasourceAction = isActionFactory<EditDatasourceAction>(NewWorkbookForEditDatasource);
